import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import Select from "react-select";
import "./Environment_Condition_Form.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import {
  allInstrumentManagement,
  allRoomType,
} from "../../../../../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import {
  Create,
  GetAll,
} from "../../../../../../../../src/features/admin/quality_management/resource_requirement/environmentcondition/Slice";

function Environment_Condition_Form({ handleClose }) {
  const {
    register,
    handleSubmit,
    control,
    watch,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      rooms: [
        {
          room_type_id: null,
          temp: "",
          rh: "",
          status: true,
        },
      ],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "rooms",
  });

  const selectedRooms = watch("rooms") || [];

  const dispatch = useDispatch();

  const all_instruments = useSelector(
    (state) => state.common.all_instrument_management,
  );

  const all_room_type = useSelector((state) => state.common.all_room_type);

  useEffect(() => {
    dispatch(allInstrumentManagement());
    dispatch(allRoomType());
  }, [dispatch]);

  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  const onSubmit = async (data) => {
    try {
      const payload = {
        instrument_management_id: data.instrument_management_id,
        unique_id: data.unique_id,
        calibration_certificate_no: data.calibration_certificate_no,
        calibration_valid_up_to: data.next_calibration_due,
        status: true,
        rooms: data.rooms.map((r) => ({
          room_type_id: r.room_type_id,
          temp: r.temp,
          rh: r.rh,
          date: r.date,
          status: r.status ?? true,
        })),
      };

      const res = await dispatch(Create(payload));

      if (res.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());

        // reset form
        setValue("instrument_management_id", null);
        setValue("unique_id", "");
        setValue("calibration_certificate_no", "");
        setValue("next_calibration_due", "");

        setValue("rooms", [
          {
            room_type_id: null,
            temp: "",
            rh: "",
            status: true,
          },
        ]);

        setSuccess(true);
        setTimeout(() => setSuccess(false), 3000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <section className="Legal_Entity_Form">
        <div className="white_container customer_section">
          {/* ================= DETAILS OF INSTRUMENT USED ================= */}
          <div className="note_text_holder">
            <p className="red_text">Details Of Instrument Used:</p>
          </div>

          <div className="row">
            <div className="col-md-6">
              <Form.Group className="form_group">
                <Form.Label>Instrument</Form.Label>
                <Controller
                  name="instrument_management_id"
                  control={control}
                  rules={{ required: "Instrument is required" }}
                  render={({ field }) => (
                    <Select
                      options={all_instruments}
                      isClearable
                      value={
                        all_instruments?.find((o) => o.value === field.value) ||
                        null
                      }
                      onChange={(option) => {
                        if (!option) {
                          field.onChange(null);

                          setValue("unique_id", "");
                          setValue("calibration_certificate_no", "");
                          setValue("next_calibration_due", "");
                          return;
                        }

                        field.onChange(option.value);

                        setValue("unique_id", option.data.unique_id);
                        setValue(
                          "calibration_certificate_no",
                          option.data.calibration_certificate_no,
                        );
                        setValue(
                          "next_calibration_due",
                          option.data.next_calibration_due?.split("T")[0],
                        );
                      }}
                    />
                  )}
                />
                {errors.instrument_management_id && (
                  <Form.Text className="text-danger">
                    {errors.instrument_management_id.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group className="form_group">
                <Form.Label>Unique ID</Form.Label>
                <Form.Control
                  placeholder="Unique ID"
                  {...register("unique_id")}
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group className="form_group">
                <Form.Label>Calibration Certificate No</Form.Label>
                <Form.Control
                  placeholder="Certificate No"
                  {...register("calibration_certificate_no")}
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group className="form_group">
                <Form.Label>Calibration Valid Up To</Form.Label>
                <Form.Control
                  type="date"
                  {...register("next_calibration_due", {
                    required: "Date is required",
                    // validate: (value) => {
                    //   const year = value.split("-")[0];

                    //   if (year.length !== 4) {
                    //     return "Year must be exactly 4 digits";
                    //   }

                    //   const selectedDate = new Date(value);
                    //   const today = new Date();
                    //   today.setHours(0, 0, 0, 0);

                    //   if (selectedDate < today) {
                    //     return "Past dates are not allowed";
                    //   }

                    //   return true;
                    // },
                  })}
                  onChange={(e) => {
                    let value = e.target.value;
                    const parts = value.split("-");

                    if (parts[0] && parts[0].length > 4) {
                      parts[0] = parts[0].slice(0, 4);
                      e.target.value = parts.join("-");
                    }
                  }}
                />
              </Form.Group>
            </div>
          </div>

          <hr />

          {/* ================= ENVIRONMENTAL CONDITION ================= */}
          <div className="note_text_holder">
            <p className="red_text">Record Environmental Condition :</p>
          </div>

          <div className="row">
            {fields.map((item, index) => {
              // collect selected room ids except current row
              const selectedRoomIds = selectedRooms
                .map((r, i) => (i !== index ? r?.room_type_id : null))
                .filter(Boolean);

              // filter options
              const filteredRoomOptions = all_room_type?.filter(
                (opt) => !selectedRoomIds.includes(opt.value),
              );

              return (
                <div className="row mb-3" key={item.id}>
                  <div className="col-md-4">
                    <Form.Group className="form_group">
                      <Form.Label>Room</Form.Label>

                      <Controller
                        name={`rooms.${index}.room_type_id`}
                        control={control}
                        rules={{ required: "Room is required" }}
                        render={({ field }) => (
                          <Select
                            options={filteredRoomOptions}
                            isClearable
                            value={
                              filteredRoomOptions?.find(
                                (o) => o.value === field.value,
                              ) || null
                            }
                            onChange={(e) => field.onChange(e ? e.value : null)}
                            placeholder="Select Room"
                          />
                        )}
                      />

                      {errors?.rooms?.[index]?.room_type_id && (
                        <Form.Text className="text-danger">
                          {errors.rooms[index].room_type_id.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-md-3">
                    <Form.Group className="form_group">
                      <Form.Label>
                        <b>Temp (°C)</b>
                      </Form.Label>
                      <Form.Control
                        placeholder="Enter Temp"
                        {...register(`rooms.${index}.temp`, {
                          required: "Temperature is required",
                          pattern: {
                            value: /^[0-9]+(\.[0-9]+)?$/, // allows integer & decimal
                            message: "Only numeric values are allowed",
                          },
                          min: {
                            value: 0,
                            message: "Temperature must be at least 0°C",
                          },
                          max: {
                            value: 100,
                            message: "Temperature must not exceed 100°C",
                          },
                        })}
                        onKeyDown={(e) => {
                          const value = e.target.value;

                          // Allow control keys
                          if (
                            [
                              "Backspace",
                              "Delete",
                              "Tab",
                              "ArrowLeft",
                              "ArrowRight",
                            ].includes(e.key)
                          ) {
                            return;
                          }

                          // Allow numbers
                          if (/^[0-9]$/.test(e.key)) {
                            return;
                          }

                          // Allow ONE decimal point
                          if (e.key === "." && !value.includes(".")) {
                            return;
                          }

                          // Block everything else
                          e.preventDefault();
                        }}
                      />
                      {errors?.rooms?.[index]?.temp && (
                        <p className="text-danger">
                          {errors.rooms[index].temp.message}
                        </p>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-md-3">
                    <Form.Group className="form_group">
                      <Form.Label>
                        <b>RH (%)</b>
                      </Form.Label>
                      <Form.Control
                        placeholder="Enter RH"
                        {...register(`rooms.${index}.rh`, {
                          required: "RH is required",
                          pattern: {
                            value: /^[0-9]+(\.[0-9]+)?$/, // allow integer & decimal
                            message: "Only numeric values are allowed",
                          },
                          min: {
                            value: 0,
                            message: "RH must be at least 0%",
                          },
                          max: {
                            value: 100,
                            message: "RH must not exceed 100%",
                          },
                        })}
                        onKeyDown={(e) => {
                          const value = e.target.value;

                          // Allow control keys
                          if (
                            [
                              "Backspace",
                              "Delete",
                              "Tab",
                              "ArrowLeft",
                              "ArrowRight",
                            ].includes(e.key)
                          ) {
                            return;
                          }
                          if (e.key === "." && !value.includes(".")) {
                            return;
                          }
                          // Allow numbers
                          if (/^[0-9]$/.test(e.key)) {
                            return;
                          }

                          // Block everything else
                          e.preventDefault();
                        }}
                      />
                      {errors?.rooms?.[index]?.rh && (
                        <p className="text-danger">
                          {errors.rooms[index].rh.message}
                        </p>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-md-3">
                    <Form.Group className="form_group">
                      <Form.Label>
                        <b>Date</b>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        placeholder="Enter Date"
                        {...register(`rooms.${index}.date`, {
                          required: "Date is required",
                          // validate: (value) => {
                          //   const year = value.split("-")[0];

                          //   if (year.length !== 4) {
                          //     return "Year must be exactly 4 digits";
                          //   }

                          //   const selectedDate = new Date(value);
                          //   const today = new Date();
                          //   today.setHours(0, 0, 0, 0);

                          //   if (selectedDate < today) {
                          //     return "Past dates are not allowed";
                          //   }

                          //   return true;
                          // },
                        })}
                        onChange={(e) => {
                          let value = e.target.value;
                          const parts = value.split("-");

                          if (parts[0] && parts[0].length > 4) {
                            parts[0] = parts[0].slice(0, 4);
                            e.target.value = parts.join("-");
                          }
                        }}
                      />
                      {errors?.rooms?.[index]?.date && (
                        <p className="text-danger">
                          {errors.rooms[index].date.message}
                        </p>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-md-2 d-flex align-items-end">
                    {fields.length > 1 && (
                      <Button variant="danger" onClick={() => remove(index)}>
                        Remove
                      </Button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          <div className="add_another_holder">
            <div>
              <span
                style={{ cursor: "pointer" }}
                onClick={() =>
                  append({
                    room_type_id: null,
                    temp: "",
                    rh: "",
                    status: true,
                  })
                }
              >
                <FontAwesomeIcon icon={faCirclePlus} /> Add Another Document
              </span>
            </div>
          </div>

          {/* ================= ACTION BUTTONS ================= */}
          <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button
                  type="button"
                  className="permission_btn No_btn"
                  onClick={() => reset()}
                >
                  Reset
                </Button>

                <Button
                  type="button"
                  className="permission_btn Yes_btn"
                  // onClick={handleSubmit(() => setSuccess(true))}
                  onClick={handleSubmit(onSubmit)}
                >
                  Save
                </Button>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Environment_Condition_Form;
